import React, { Dispatch, FC, SetStateAction, useState } from 'react';
import { ReactComponent as PurchasesIcon } from 'images/new-icons/purchases.svg';
import { ReactComponent as BookingIcon } from 'images/new-icons/bookings.svg';
import { ReactComponent as FavoritesIcon } from 'images/new-icons/favorites.svg';
import { ReactComponent as SettingsIcon } from 'images/new-icons/settings.svg';
import styles from './ProfileMenu.module.scss';
import { Menu } from './ProfileMenu';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ForwardArrow from '../UI/ForwardArrow';
const menuItems = [
  {
    icon: <PurchasesIcon />,
    title: 'Purchases',
  },
  {
    icon: <BookingIcon />, 
    title: 'Bookings',
  },
  {
    icon: <SettingsIcon />,
    title: 'Settings',
  },
  {
    icon: <FavoritesIcon />,
    title: 'Favorites',
  },
];



type Props = {
  setProfileMenu: any
}

const ProfileMenuItems: FC<Props> = ({ setProfileMenu }) => {
  const navigate = useNavigate();
  const {t }=  useTranslation() as any 
  return (
    <div style={{ padding: '0px 8px' }}>
      {menuItems.map((item, index) => (
        <div key={index} className={styles.profile_menu_items} onClick={() => {
          if (item.title === 'Purchases') {
            navigate('/profile-menu/purchases');
          } else {
            setProfileMenu(item.title)
          }
        }}>
          {item.icon}
          <div className={styles.profile_menu_items__title}>{t(item.title)}</div>
          <div className={styles.profile_menu_items__arrow}>
            <ForwardArrow style={{ color: '#00000080' }} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProfileMenuItems;
